/**
 * Star
 *
 * @param int x
 * @param int y
 * @param int length
 * @param opacity
 * @param mouseFactor mousemove translation factor
 */
export class Star {
    x: number;
    y: number;
    length: number;
    opacity: number;
    factor: number;
    increment: number;
    mousemoveFactor: number;

    constructor(x: number, y: number, length: number, opacity: number) {
        this.x = x;
        this.y = y;
        this.length = length;
        this.opacity = opacity;
        this.factor = 1;
        this.increment = Math.random() * 0.03;
        this.mousemoveFactor = Math.random() * Math.random() > 0.5 ? 1 : -1;
    }

    draw(ctx: CanvasRenderingContext2D, offsetX: number, canvasWidth: number, canvasHeight: number) {
        ctx.save();
        ctx.translate(this.x + offsetX * this.mousemoveFactor, this.y);

        // Change the opacity
        if (this.opacity > 1) {
            this.factor = -1;
        } else if (this.opacity <= 0) {
            this.factor = 1;
            this.x = Math.round((Math.random() * 2 - 1) * canvasWidth);
            this.y = Math.round(Math.random() * canvasHeight);
        }

        this.opacity += this.increment * this.factor;

        ctx.beginPath();

        for (var i = 5; i--; ) {
            ctx.lineTo(0, this.length);
            ctx.translate(0, this.length);
            ctx.rotate((Math.PI * 2) / 10);
            ctx.lineTo(0, -this.length);
            ctx.translate(0, -this.length);
            ctx.rotate(-((Math.PI * 6) / 10));
        }

        ctx.lineTo(0, this.length);
        ctx.closePath();
        ctx.fillStyle = 'rgba(255, 255, 200, ' + this.opacity + ')';
        ctx.fill();

        ctx.restore();
    }
}
